import {getOffset} from '../util/dom';

/**
 * A Showroom instance loaded in an html frame element.
 */
export class ShowroomFrame {
    private selectCallbacks: Function[] = [];
    private errorCallbacks: Function[] = [];
    private openOverlayCallbacks: Function[] = [];
    private closeOverlayCallbacks: Function[] = [];

    constructor(public frameElement: HTMLIFrameElement, public url: string) {
    }

    load() {
        // load the app //
        this.frameElement.src = this.url;

        window.addEventListener("message", (event) => {
            const message = JSON.parse(event.data);

            if (this.frameElement.contentWindow !== event.source) {
                // Don't accept messages from unknown source
                return;
            }

            let callbacks: Function[] = [];
            switch (message.type) {
                case 'select':
                    callbacks = this.selectCallbacks;
                    break;
                case 'error':
                    callbacks = this.errorCallbacks;
                    break;
                case 'resize':
                    this.frameElement.style.height = (message.data) + 'px';
                    break;
                case 'scroll':
                    let offset = message.data.offset;
                    if (message.data.includeIframeOffset) {
                        const iframeOffset = getOffset(this.frameElement);
                        offset += iframeOffset.top;
                    }
                    window.scrollTo(0, offset);
                    break;
                case 'navigate':
                    if (message.data === 'back') {
                        window.history.back();
                    }
                    break;
                case 'openoverlay':
                    callbacks = this.openOverlayCallbacks;
                    break;
                case 'closeoverlay':
                    callbacks = this.closeOverlayCallbacks;
                    break;
                default:
                    break;
            }

            for (let i = 0; i < callbacks.length; i++) {
                callbacks[i].call(null, message.data);
            }
        }, false);
    }
    setFrameUrl(url: string) {
        this.url = url;
        this.frameElement.src = url;
    }
    addSelectCallback(handlerCallback: Function) {
        this.selectCallbacks.push(handlerCallback);
    }
    addErrorCallback(handlerCallback: Function) {
        this.errorCallbacks.push(handlerCallback);
    }
    addOpenOverlayCallback(handlerCallback: Function) {
        this.openOverlayCallbacks.push(handlerCallback);
    }
    addCloseOverlayCallback(handlerCallback: Function) {
        this.closeOverlayCallbacks.push(handlerCallback);
    }
};



// WEBPACK FOOTER //
// /build/~/tslint-loader!./host/ShowroomFrame.ts